<template>
  <a-form-item v-for="(option, index) in options" :key="option.id" :label="`Opción ${index + 1}`">
    <div class="input">
      <a-input v-model:value="option.value" placeholder="Escribe aquí..." />

      <a-button
        type="link"
        danger
        class="button__delete"
        :disabled="index === 0"
        @click="handleDeleteOption(index)"
      >
        <DeleteOutlined />
      </a-button>
    </div>
  </a-form-item>

  <footer>
    <a-button type="link" class="button__add" @click="handleAddOption">
      <PlusOutlined />
      Agregar otra opción
    </a-button>
  </footer>
</template>

<script setup lang="ts">
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons-vue";
import { cloneDeep } from "lodash";

import type { FormInputOption } from "@/@types/entities/forms";

const props = defineProps<{
  options: FormInputOption[];
}>();

const emit = defineEmits<{
  (e: "update:options", options: FormInputOption[]): void;
}>();

const handleDeleteOption = (index: number) => {
  const optionsClone = cloneDeep(props.options);

  optionsClone.splice(index, 1);
  emit("update:options", optionsClone);
};

const handleAddOption = () => {
  const optionsClone = cloneDeep(props.options);
  const lastElementId = optionsClone.at(-1)?.id || 0;

  optionsClone.push({ id: lastElementId + 1, value: "" });
  emit("update:options", optionsClone);
};
</script>

<style scoped lang="sass">
:deep(.ant-form-item-label)
  padding-bottom: 4px !important

:deep(.ant-form-item-label label)
  color: $gray-7 !important

.input
  display: flex
  align-items: center
  gap: 10px

.button
  &__delete
    padding: 0

  &__add
    margin-top: 10px

footer
  border-top: 1px solid $gray-4
  text-align: center
</style>
